import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const AdministratiaControlFinanciar: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Administrația Control Financiar
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Pr. Ioan (Severin) Popoiu
          </Typography>
          <Typography variant="body1">
            Administrația Control Financiar se ocupă de controlul 
            și monitorizarea aspectelor financiare ale eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdministratiaControlFinanciar;
